import { C } from "../constants/colors";

export function timeAgo(iso) {
  if (!iso) return "Never";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return mins <= 1 ? "Just now" : `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function accessStatus(expiresAt) {
  if (!expiresAt) return null;
  const diff = new Date(expiresAt) - Date.now();
  if (diff < 0) return { label: "Expired", color: C.salmon };
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  if (days <= 1) return { label: "Expires today", color: C.salmon };
  return { label: `Expires in ${days}d`, color: C.teal };
}

/* The one admin account — the same address api/chat.js and the GHL endpoints
   check. Here rather than only in MomentumHub so a small component can ask
   without importing the whole hub (and everything it imports). */
export const ADMIN_EMAIL = "tevra@tevrawood.com";

export function isAdminEmail(email) {
  return String(email || "").toLowerCase() === ADMIN_EMAIL;
}
